module.exports = __webpack_public_path__ + "img/banner.66bf85ef.png";